// extracted by mini-css-extract-plugin
module.exports = {"formcontrol":"Location_formcontrol__35cMk","container":"Location_container__1SUzo"};